// extracted by mini-css-extract-plugin
export var container = "_ch-0";
export var content = "_ch-3";
export var customerTitle = "_ch-4";
export var empty = "_ch-5";
export var gray = "_ch-6";
export var header = "_ch-7";
export var info = "_ch-8";
export var loading = "_ch-2";
export var loadingCard = "_ch-9";
export var oneLine = "_ch-a";
export var personName = "_ch-e";
export var pillContainer = "_ch-b";
export var selected = "_ch-1";
export var text = "_ch-c";
export var twoLines = "_ch-d";
export var unread = "_ch-f";
export var unreadIndicator = "_ch-g";